module.exports = __webpack_public_path__ + "aa218eada8b15bca8e3f4a441cc2f4f0.svg";